module.exports = __webpack_public_path__ + "img/onlineExpo_profile.ab05acdb.png";